export function readJson(key, fallback = null) {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return fallback;
    return JSON.parse(raw);
  } catch (error) {
    console.warn(`Lecture localStorage impossible pour "${key}".`, error);
    return fallback;
  }
}

export function readJsonArray(key) {
  const value = readJson(key, []);
  return Array.isArray(value) ? value : [];
}

export function writeJson(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.warn(`Écriture localStorage impossible pour "${key}".`, error);
    return false;
  }
}
